<ng-container *transloco="let t">
  <cw-dialog
    [open]="open()"
    [dialogTitle]="t(dialogData()?.title ?? '')"
  >
    <ng-container #componentContainer></ng-container>

    <div slot="footer">
      <cw-button
        [buttonColor]="dialogData()?.cancelButton?.color ?? 'secondary'"
        variant="outlined"
        (click)="onCancel()"
      >
        {{ t(dialogData()?.cancelButton?.label ?? 'cancel') }}
      </cw-button>
      <cw-button
        [buttonColor]="dialogData()?.confirmButton?.color ?? 'accent'"
        style="margin-left: 16px"
        (click)="onConfirm()"
      >
        {{ t(dialogData()?.confirmButton?.label ?? 'confirm') }}
      </cw-button>
    </div>
  </cw-dialog>
</ng-container>
